import React from "react";
import styled from "styled-components";
import { ReactComponent as GamingSvg } from "../images/gaming.svg";
import { motion } from "framer-motion";

const Gaming = () => {
  const constainerVariant = {
    hidden: {
      x: "-100vw",
    },
    visible: {
      x: 0,
      transition: { delay: 0.5, type: "spring", stiffness: 50 },
    },
    exit: {
      opacity: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <Container
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <p>
          Call of Duty takes up the majority of my gaming time. I also enjoy
          Naruto Shippuden: Ultimate Ninja Storm 4 and Halo.
        </p>
        <GamingSvgContainer />
      </Container>
    </>
  );
};

export default Gaming;

const Container = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 2rem;
  gap: 1rem;

  :hover {
  }

  p {
    font-size: 22px;
    flex: 1;
    display: inline-block;
    margin: 0 0 1rem 0;
    text-align: justify;
    width: 350px;
  }

  @media screen and (max-width: 760px) {
    display: block;
    margin: auto;

    p {
      font-size: 18px;
      margin-right: 1rem;
      text-align: left;
      width: 100%;
      margin-bottom: 2rem;
    }
  }
`;

const GamingSvgContainer = styled(GamingSvg)`
  width: 350px;
  height: 350px;
  object-fit: cover;
  flex: 1;
  border-radius: 10px;

  @media screen and (max-width: 760px) {
    width: 100%;
    height: 300px;
    object-fit: cover;
    flex: 1;
  }
`;
